import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import InfoBlock from '../InfoBlock/InfoBlock';
import InfoLink from '../InfoLink/InfoLink';

import {
  TXTWCL_How_can_I_manage_my_spendingX,
  TXTWCL_If_youXre_not_sure_about_takin_ELL_2,
  TXTWCL_If_youXre_not_sure_about_takin_ELL_3,
  TXTWCL_Learn_more_about_XaXResponsibl_ELL,
  TXTWCL_To_find_out_more_about_safe_ga_ELL,
  TXTWCL_You_can_also_set_a_XaXloss_lim_ELL
} from './LearnMoreAboutRG.messages.json';

const LearnMoreAboutRG = () => {
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);
  const site = useSelector(select.cms.getSiteId);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const { modal } = useDispatch<Dispatch>();

  const openRestrictDepositLimit = () => {
    isEmbedded
      ? window.starsweb?.app.execute('account/responsible/restrict-deposit-limit')
      : modal.replace([{ path: depositLimitPath }]);
  };
  const openAccumulatedLossLimit = () => {
    isEmbedded
      ? window.starsweb?.app.execute('account/responsible/accumulated-loss-limit')
      : modal.replace([{ path: '/account/responsible/accumulated-loss-limit' }]);
  };

  const getResolver = (site: Sites) => {
    switch (true) {
      case site === Sites.DE:
        return ResolverTag.RGPage;
      case site === Sites.FRA:
        return ResolverTag.RG18Logo;
      case site === Sites.GR:
        return ResolverTag.GrLimitNotIfPrompt;
      case site === Sites.US_PA:
      case site === Sites.US_NJ:
      case site === Sites.UK:
        return ResolverTag.HelpResponsibleGaming;
      default:
        return ResolverTag.SelfExclusionResponsibleGamingPS;
    }
  };

  return (
    <>
      {[Sites.FRA, Sites.GR, Sites.US_PA, Sites.US_NJ, Sites.POR, Sites.DEN, Sites.DE].includes(
        site
      ) && (
        <InfoBlock title={TXTWCL_How_can_I_manage_my_spendingX}>
          <div>
            <Translation
              {...(site === Sites.FRA
                ? TXTWCL_If_youXre_not_sure_about_takin_ELL_3
                : TXTWCL_If_youXre_not_sure_about_takin_ELL_2)}
              values={{
                a: (msg: React.ReactNode) => (
                  <StarsLink onClick={openRestrictDepositLimit}>{msg}</StarsLink>
                )
              }}
            />{' '}
            {[Sites.GR, Sites.DE].includes(site) && (
              <Translation
                {...TXTWCL_You_can_also_set_a_XaXloss_lim_ELL}
                values={{
                  a: (msg: React.ReactNode) => (
                    <StarsLink onClick={openAccumulatedLossLimit}>{msg}</StarsLink>
                  )
                }}
              />
            )}
          </div>
        </InfoBlock>
      )}
      <p>
        <InfoLink
          linkTranslation={
            site === Sites.UK
              ? TXTWCL_Learn_more_about_XaXResponsibl_ELL
              : TXTWCL_To_find_out_more_about_safe_ga_ELL
          }
          resolverTag={getResolver(site)}
        />
      </p>{' '}
    </>
  );
};

export default LearnMoreAboutRG;
